import React from 'react';
import classNames from 'classnames';
import { IconProp } from 'models/Icon';
import BellIcon from 'icons/Bell.icon';

import './RfiActivityEmptyState.styles.scss';

type RfiActivityEmptyStateProps = {
  className?: string;
  Icon?: IconProp;
  title: string;
  description: string;
};

const RfiActivityEmptyState: React.FC<RfiActivityEmptyStateProps> = ({
  className,
  Icon = BellIcon,
  title,
  description,
}) => (
  <div className={classNames('rfi-activity-empty-state', className)}>
    <Icon />

    <p className="rfi-activity-empty-state__title">{title}</p>
    <p className="rfi-activity-empty-state__description">{description}</p>
  </div>
);

export default RfiActivityEmptyState;
